import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_28: FaireProductEntity = {
  token: "catalog_prod_prod-28",
  type: "product",
  name: "Tabletop Accessory",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1602874801007-bd458bb1b8b6?w=400&h=400&fit=crop",
  priceDollars: 54.83,
  msrpDollars: 137.07,
  sku: "PA0028",
  caseSize: 4,
  material: "Ceramic",
  collectionToken: "col_pattern-play",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 182,
  description: "Beautiful Pattern Play piece perfect for any home.",
  categoryTokens: ["catalog_cat_home-fragrances"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
